import * as React from "react";
const SvgPhonePylon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeWidth: 2, d: "M1 8V5h22v3M8 9h8m0 4-9 2m-1 4 13 4m0 2L14 1h-4L5 25M19 5v3M5 5v3" }));
export default SvgPhonePylon;
